import { PropsWithChildren } from 'react';
import { tv } from '../../utils/tv';

const style = tv({
  base: `
    truncate
    text-paragraphBold
  `
});

type Props = PropsWithChildren;

export const NavContextTitle = ({ children }: Props) => {
  return <div className={style()}>{children}</div>;
};
